
import pt_BR from 'vee-validate/dist/locale/pt_BR';
import pt_PT from 'vee-validate/dist/locale/pt_PT';
import es from 'vee-validate/dist/locale/es';

import VeeValidate, { Validator } from 'vee-validate';
import Vue from 'vue';

//-----------------------
import ValidaCPF from '../utils/validators/Validators';
import ValidaCNPJ from '../utils/validators/ValidatorsCNPJ';
import NIF from '../utils/validators/NIF';
import EmailOrNIF from '../utils/validators/EmailOrNIF';
import ValidaData from '../utils/validators/ValidatorData';
import ValidaMenor from '../utils/validators/ValidatorMenor';
import IdadeCompat from '../utils/validators/IdadeCompat';
import LoginHibrido from '../utils/validators/LoginHibrido';
import CustomMessages_pt_BR from './../../../lang/validator/pt_BR';
import CustomMessages_pt_PT from './../../../lang/validator/pt_PT';
import CustomMessages_es from './../../../lang/validator/es';
import MinimumPrice from '../utils/validators/MinimumPrice';
import SelectValidator from './../utils/validators/SelectValidator';
import Prefix from './../utils/validators/Prefix';
import NotPrefix from './../utils/validators/NotPrefix';

Validator.extend('cpf', ValidaCPF);
Validator.extend('nif', NIF);
Validator.extend('email_or_nif', EmailOrNIF);
Validator.extend('cnpj', ValidaCNPJ);
Validator.extend('menor', ValidaMenor);
Validator.extend('datanasc', ValidaData);
Validator.extend('idadecompat', IdadeCompat);
Validator.extend('login_hibrido', LoginHibrido);
Validator.extend('minimum_price', MinimumPrice);
Validator.extend('required_select', SelectValidator);
Validator.extend('prefix', Prefix);
Validator.extend('not_prefix', NotPrefix);

// Localize takes the locale object as the second argument (optional) and merges it.
Validator.localize('pt_BR', CustomMessages_pt_BR);
Validator.localize('pt_BR', pt_BR);

Validator.localize('pt_PT', CustomMessages_pt_PT);
Validator.localize('pt_PT', pt_PT);

Validator.localize('es', CustomMessages_es);
Validator.localize('es', es);

// Install the Plugin.
Vue.use(VeeValidate,{
    locale: window.locale,
    fieldsBagName: 'veeFields'
});
